import styled from 'styled-components';
import {dFlexColumn, alignStart, dFlex, flexWrap} from '../../../globalVariables/GlobalFlex';
import {getFontSize, getFontWeight, getToken, getSpacing} from '@tickchak/react-share/app';

export const relatedSection = styled.div`
    ${dFlexColumn}
    ${alignStart}
    width: 100%;
    gap: ${getSpacing('spaceLg')};
`;

export const relatedTitle = styled.span`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('bold')};
    line-height: ${getToken('typography.lineHeight.body')};
    color: ${getToken('color.text.default')};
    text-align: start;
    width: 100%;
`;

export const relatedChips = styled.div`
    ${dFlex}
    ${flexWrap}
    gap: ${getSpacing('spaceSm')};
    width: 100%;
`;
